import PopupComponent from "./popup.js";
import PopupBackdrop from "./popup-backdrop.js";
import PopupClose from "./popup-close.js";
export { usePopupBackdrop } from "./popup-backdrop.js";
const Popup = PopupComponent;
Popup.Backdrop = PopupBackdrop;
Popup.Close = PopupClose;
export default Popup;
